import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { provideServiceWorker } from '@angular/service-worker';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { GlobalErrorHandler } from '@errors/global-error-handler.service';
import { IonicStorageModule } from '@ionic/storage-angular';
import { authTokenInterceptor, HttpSilentAuthService } from '@auth';
import { IHttpAuthHandler } from '@data-services/http';
import { MESSAGE_SERVICE_TOKEN } from '@services/messages';
import { MessageService } from '@services/message.service';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: IHttpAuthHandler, useClass: HttpSilentAuthService },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: MESSAGE_SERVICE_TOKEN, useExisting: MessageService },
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authTokenInterceptor])),
    provideIonicAngular(),
    importProvidersFrom(IonicStorageModule.forRoot({ name: 'microbuild-management-mobile' })),
    provideTranslateService({
      defaultLanguage: 'no',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'no',
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
};
